
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personalized-discount",
      function () {
        return require("private-next-pages/personalized-discount/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personalized-discount"])
      });
    }
  